import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import { createMarkerContent, loadScript, map_settings } from "../../../../map";
import { fetchFtmCurrentLocation } from "../../service";

const FtmMap = () => {
    const { ftm_id } = useParams();

    const mapRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [ftmLocation, setFtmLocation] = useState(null);

    // Fetch FTM Location
    useEffect(() => {
        const getFtmCurrentLocation = async () => {
            try {
                const response = await fetchFtmCurrentLocation(ftm_id);
                if (response?.status === "Success") {
                    setFtmLocation(response.location);
                } else {
                    setFtmLocation(null);
                }
            } catch (error) {
                console.error("Error fetching location:", error);
                setFtmLocation(null);
            }
        };

        getFtmCurrentLocation();
    }, [ftm_id]);

    // Load Google Maps Script
    useEffect(() => {
        loadScript(
            map_settings.map_script_url,
            () => setMapLoaded(true),
            () => console.error("Failed to load Google Maps script.")
        );
    }, []);

    // Init Map AFTER script + data loaded
    useEffect(() => {
        if (!mapLoaded || !ftmLocation) return;

        if (!window.google || !window.google.maps) {
            console.error("Google Maps API missing");
            return;
        }

        const map = new window.google.maps.Map(mapRef.current, {
            center: { lat: ftmLocation.latitude, lng: ftmLocation.longitude },
            zoom: 13,
            mapId: "PREVIOUS_JOBS_MAP"
        });

        const markerPos = new window.google.maps.LatLng(
            ftmLocation.latitude,
            ftmLocation.longitude
        );

        // Create marker
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: markerPos,
            map,
            content: createMarkerContent(map_settings.ftm_map_icon)
        });

        // Create InfoWindow
        const infoWindow = new window.google.maps.InfoWindow({
            content: `
                <div style="padding: 1px">
                    <h6 style="margin:0;">Tradesperson location</h6>
                    <div>Lat: ${ftmLocation.latitude}</div>
                    <div>Lng: ${ftmLocation.longitude}</div>
                </div>
            `
        });

        // Open InfoWindow on marker click
        marker.addListener("click", () => {
            infoWindow.open({
                anchor: marker,
                map
            });
        });

    }, [mapLoaded, ftmLocation]);

    return (
        <div className="card mt-4">
            <div className="card-body">
                <div
                    style={{ width: "100%", height: "300px" }}
                    ref={mapRef}
                />
            </div>
        </div>
    );
};

export default FtmMap;
